<template>
  <v-select
    multiple
    :label="label"
    v-model="rights"
    :items="props.options"
    return-object>
    <template v-slot:item="{ props: itemProps, item }">
      <v-list-item
        v-bind="itemProps"
        :disabled="itemProps.requires && !(model & itemProps.requires)">
        <template v-slot:prepend>
          <v-icon>{{
            model & item.value
              ? "mdi-checkbox-outline"
              : "mdi-checkbox-blank-outline"
          }}</v-icon>
        </template>
        <template v-slot:title>
          {{ item.title }}
          {{ t("views.licence.modules." + itemProps.valueName + ".extra") }}
        </template>
      </v-list-item>
    </template>
  </v-select>
</template>

<script lang="ts" setup>
import { useTranslation } from "i18next-vue";
import { computed } from "vue";

const { t } = useTranslation();

const model = defineModel<number>();

const props = defineProps<{
  options: { value: number; title: string }[];
  label: string;
}>();

const rights = computed({
  get: () => {
    return props.options
      .filter((option) => option.value & model.value)
      .map((option) => option.value);
  },
  set: (value: { value: number; props: { requires?: number } }[]) => {
    console.log("value", value);
    let currentValues = value.map((item) => item.value);
    model.value = value.reduce((result, item) => {
      if (item.props.requires && !currentValues.includes(item.props.requires)) {
        currentValues = currentValues.filter((v) => v !== item.value);
        return result;
      }
      return item.value ^ result;
    }, 0);
    console.log(model.value);
  }
});
</script>
